// Shared inline styles for the interview pages. Inline (not CSS modules)
// to mirror the surrounding auth/PersonalVideoMessageFlow pattern and
// avoid one-off .module.css files for three small pages.

export const overlay = {
  position: 'fixed',
  inset: 0,
  zIndex: 50,
  background: 'radial-gradient(circle at center, #1f2330, #07080c)',
  color: '#fff',
  fontFamily: 'inherit',
  overflowY: 'auto',
};

export const center = (isMobile) => ({
  minHeight: '100vh',
  display: 'flex',
  alignItems: isMobile ? 'flex-start' : 'center',
  justifyContent: 'center',
  padding: isMobile ? '24px 16px' : '32px 24px',
  boxSizing: 'border-box',
});

export const card = (isMobile) => ({
  width: '100%',
  maxWidth: '720px',
  display: 'flex',
  flexDirection: 'column',
  gap: isMobile ? '16px' : '24px',
});

export const heading = (isMobile) => ({
  margin: 0,
  fontSize: isMobile ? '1.5rem' : '2rem',
  fontWeight: 800,
  letterSpacing: '-0.01em',
  textAlign: 'center',
});

export const subheading = {
  margin: '6px auto 0',
  maxWidth: '520px',
  color: '#ffd98a',
  fontSize: '1rem',
  fontWeight: 600,
  lineHeight: 1.4,
  textAlign: 'center',
};

export const body = {
  margin: '6px auto 0',
  maxWidth: '560px',
  color: '#b9bdc7',
  fontSize: '0.95rem',
  lineHeight: 1.5,
  textAlign: 'center',
};

export const primaryBtn = (disabled) => ({
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '10px',
  padding: '14px 36px',
  minHeight: '48px',
  lineHeight: 1,
  borderRadius: '999px',
  border: 'none',
  background: disabled ? 'rgba(255,255,255,0.08)' : '#5aa5ef',
  color: disabled ? '#7f828b' : '#fff',
  fontFamily: 'inherit',
  fontSize: '1rem',
  fontWeight: 800,
  cursor: disabled ? 'not-allowed' : 'pointer',
  boxShadow: disabled ? 'none' : '0 8px 22px rgba(90, 165, 239, 0.40)',
});

export const secondaryBtn = {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '12px 28px',
  minHeight: '46px',
  lineHeight: 1,
  borderRadius: '999px',
  border: '1px solid rgba(255,255,255,0.18)',
  background: 'rgba(255,255,255,0.06)',
  color: '#cfd1da',
  fontFamily: 'inherit',
  fontSize: '0.95rem',
  fontWeight: 700,
  cursor: 'pointer',
};

export const ctaRow = {
  display: 'flex',
  gap: '12px',
  justifyContent: 'center',
  flexWrap: 'wrap',
  marginTop: '8px',
};

// 16:9 video container — used on host setup, guest landing, and the call.
export const videoFrame = {
  position: 'relative',
  width: '100%',
  aspectRatio: '16 / 9',
  background: '#000',
  borderRadius: '14px',
  overflow: 'hidden',
  border: '1px solid rgba(255,255,255,0.10)',
};

export const videoTag = {
  width: '100%',
  height: '100%',
  objectFit: 'cover',
  // Mirror the local preview so it feels like a mirror, not surveillance
  // footage. The recorded canvas does NOT mirror — only the live preview.
  transform: 'scaleX(-1)',
};

// useIsMobile hook lives in a module that re-runs on every consumer to
// keep things terse; if you reach a 4th consumer, extract to a hook file.
export const isMobileQuery = () => (typeof window !== 'undefined' ? window.innerWidth <= 640 : false);
